import React, { useState, useEffect } from 'react';
import './calibrationkit.css';
import TrashIcon from '../../components/icons/TrashIcon';

const CalibrationKit = () => {
  const initialCalibrationKits = [
    {
      assignedDealer: '57',
      zigid: 'AB_ZIG_c4_dd_57_8c_a2_e4',
      model: '2',
      status: 'assigned',
      createdDate: '03/03/2024 04:34:00',
      active: 'assigned'
    },
    {
      assignedDealer: '257',
      zigid: 'AB_ZIG_89918540400572500375',
      model: '2',
      status: 'assigned',
      createdDate: '03/03/2024 04:34:00',
      active: 'assigned'
    },
    {
      assignedDealer: '257',
      zigid: 'AB_ZIG_89918540400572500367',
      model: '2',
      status: 'assigned',
      createdDate: '03/17/2024 04:34:00',
      active: 'assigned'
    },
    {
      assignedDealer: '287',
      zigid: '222',
      model: '1',
      status: 'notassigned',
      createdDate: '08/11/2025 12:25:58',
      active: 'notassigned'
    },
    {
      assignedDealer: '287',
      zigid: 'AB_ZIG_8991854040057250037588',
      model: '2',
      status: 'removed',
      createdDate: '08/11/2025 13:33:05',
      active: 'removed'
    },
    {
      assignedDealer: '307',
      zigid: 'TS23444',
      model: '1',
      status: 'assigned',
      createdDate: '08/11/2025 15:26:33',
      active: 'assigned'
    },
    {
      assignedDealer: '307',
      zigid: 'TS23444',
      model: '1',
      status: 'notassigned',
      createdDate: '08/11/2025 15:28:43',
      active: 'notassigned'
    },
    {
      assignedDealer: '25',
      zigid: 'ABCD',
      model: '1',
      status: 'notassigned',
      createdDate: '12/03/2025 10:59:53',
      active: 'notassigned'
    },
    {
      assignedDealer: '25',
      zigid: 'AB_ZIG_c4_dd_57_8c_xx_xx',
      model: '2',
      status: 'notassigned',
      createdDate: '12/05/2025 10:48:56',
      active: 'notassigned'
    },
  ];

  const [allCalibrationKits] = useState([...initialCalibrationKits]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [goToPage, setGoToPage] = useState('');
  const [selectedKit, setSelectedKit] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const filteredKits = allCalibrationKits.filter(kit =>
    [kit.assignedDealer, kit.zigid, kit.model, kit.status, kit.active]
      .some(field => field && field.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredKits.length / rowsPerPage);
  const indexOfFirst = (currentPage - 1) * rowsPerPage;
  const currentItems = filteredKits.slice(indexOfFirst, indexOfFirst + rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setGoToPage('');
    }
  };

  const handleGoToPage = (e) => {
    e.preventDefault();
    const pageNum = parseInt(goToPage);
    if (!isNaN(pageNum) && pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
      setGoToPage('');
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let end = Math.min(totalPages, start + maxVisiblePages - 1);
    
    if (end - start + 1 < maxVisiblePages) {
      start = Math.max(1, end - maxVisiblePages + 1);
    }
    
    if (start > 1) {
      pages.push(1);
      if (start > 2) pages.push('...');
    }
    
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    
    if (end < totalPages) {
      if (end < totalPages - 1) pages.push('...');
      pages.push(totalPages);
    }
    
    return pages;
  };

  const getStatusBadgeClass = (status) => {
    switch(status) {
      case 'assigned':
        return 'status-assigned';
      case 'notassigned':
        return 'status-notassigned';
      case 'removed':
        return 'status-removed';
      default:
        return '';
    }
  };

  const getStatusText = (status) => {
    switch(status) {
      case 'assigned':
        return 'Assigned';
      case 'notassigned':
        return 'Not Assigned';
      case 'removed':
        return 'Removed';
      default:
        return status;
    }
  };

  const handleEdit = (kit) => {
    setSelectedKit(kit);
    setIsEditMode(true);
    setIsDialogOpen(true);
  };

  const handleDelete = (kit) => {
    if (window.confirm(`Are you sure you want to delete calibration kit for dealer ${kit.assignedDealer}?`)) {
      // Delete logic here
      console.log('Delete kit:', kit);
    }
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    setSelectedKit(null);
    setIsEditMode(false);
  };

  return (
    <div className="calibration-app">
      <div className="calibration-card">
        {/* Header */}
        <div className="calibration-header">
          <div>
            <h1 className="calibration-title">Calibration Kit</h1>
            <p className="calibration-subtitle">Manage calibration kits and device assignments</p>
          </div>
          {/* <button className="add-calibration-btn">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M9 3v12M3 9h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            Add Calibration Kit
          </button> */}
        </div>

        {/* Filters */}
        <div className="calibration-filters">
          <div className="search-wrapper">
            <svg className="search-svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M12.5 12.5L16 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            <input
              type="text"
              className="search-input"
              placeholder="Search by Dealer, ZigID, Model, or Status..."
              value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
            />
            {searchTerm && (
              <button className="clear-btn" onClick={() => setSearchTerm('')}>×</button>
            )}
          </div>
          <div className="records-info">
            <span className="records-label">Show</span>
            <select 
              className="records-select"
              value={rowsPerPage} 
              onChange={e => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}
            >
              {[10, 25, 50, 100].map(n => <option key={n}>{n}</option>)}
            </select>
            <span className="records-label">entries</span>
          </div>
        </div>

        {/* Table */}
        <div className="calibration-table-container">
          <table className="calibration-table">
            <thead>
              <tr>
                <th>Assigned Dealer</th>
                <th>Zigid</th>
                <th>Model</th>
                <th className="text-center">Status</th>
                <th>Created Date</th>
                <th>Active</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((kit, idx) => (
                <tr key={idx}>
                  <td className="dealer-cell">{kit.assignedDealer}</td>
                  <td className="zigid-cell">{kit.zigid}</td>
                  <td className="model-cell">
                    <span className="model-badge">v{kit.model}</span>
                  </td>
                  <td className="status-cell">
                    <span className={`status-badge ${getStatusBadgeClass(kit.status)}`}>
                      {getStatusText(kit.status)}
                    </span>
                  </td>
                  <td className="date-cell">{kit.createdDate}</td>
                  <td className="active-cell">
                    <span className={`active-badge ${getStatusBadgeClass(kit.active)}`}>
                      {getStatusText(kit.active)}
                    </span>
                  </td>
                  <td className="actions-cell text-center text-center">
                    <div className="action-buttons">
                      <button 
                        className="action-icon edit-btn"
                        onClick={() => handleEdit(kit)}
                        title="Edit"
                      >
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M10 1L13 4L4.5 12.5H1V9L10 1Z" stroke="currentColor" strokeWidth="1.2"/>
                        </svg>
                      </button>
                      <button 
                        className="action-icon delete-btn"
                        onClick={() => handleDelete(kit)}
                        title="Delete"
                      >
                        <TrashIcon />
                      </button>
                    </div>
                   </td>
                 </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination-container">
          <div className="pagination-info">
            Showing {indexOfFirst + 1} to {Math.min(indexOfFirst + rowsPerPage, filteredKits.length)} of {filteredKits.length} entries
          </div>
          <div className="pagination-controls">
            <select 
              className="rows-select"
              value={rowsPerPage} 
              onChange={e => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}
            >
              {[10, 25, 50, 100].map(n => <option key={n}>{n}</option>)}
            </select>
            <button 
              className="page-btn" 
              onClick={() => handlePageChange(1)} 
              disabled={currentPage === 1}
            >
              «
            </button>
            <button 
              className="page-btn" 
              onClick={() => handlePageChange(currentPage - 1)} 
              disabled={currentPage === 1}
            >
              ‹
            </button>
            {getPageNumbers().map((p, i) => (
              p === '...' 
                ? <span key={i} className="page-dots">…</span>
                : (
                  <button 
                    key={p} 
                    className={`page-btn ${currentPage === p ? 'active' : ''}`}
                    onClick={() => handlePageChange(p)}
                  >
                    {p}
                  </button>
                )
            ))}
            <button 
              className="page-btn" 
              onClick={() => handlePageChange(currentPage + 1)} 
              disabled={currentPage === totalPages}
            >
              ›
            </button>
            <button 
              className="page-btn" 
              onClick={() => handlePageChange(totalPages)} 
              disabled={currentPage === totalPages}
            >
              »
            </button>
          </div>
          <div className="goto-wrapper">
            <span>Go to</span>
            <form onSubmit={handleGoToPage}>
              <input
                type="number"
                min="1"
                max={totalPages}
                value={goToPage}
                onChange={e => setGoToPage(e.target.value)}
                placeholder="page"
              />
              <button type="submit">Go</button>
            </form>
          </div>
        </div>
      </div>

      {/* Edit Dialog Modal */}
      {isDialogOpen && selectedKit && (
        <div className="dialog-overlay" onClick={closeDialog}>
          <div className="dialog-container" onClick={(e) => e.stopPropagation()}>
            <div className="dialog-header">
              <h2 className="dialog-title">{isEditMode ? 'Edit Calibration Kit' : 'Calibration Kit Details'}</h2>
              <button className="dialog-close" onClick={closeDialog}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M3 3L15 15M15 3L3 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </button>
            </div>
            <div className="dialog-body">
              {isEditMode ? (
                // Edit Form
                <form className="edit-form">
                  <div className="form-group">
                    <label className="form-label">Assigned Dealer</label>
                    <input type="text" className="form-input" defaultValue={selectedKit.assignedDealer} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Zigid</label>
                    <input type="text" className="form-input" defaultValue={selectedKit.zigid} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Model</label>
                    <select className="form-input" defaultValue={selectedKit.model}>
                      <option value="1">Model 1</option>
                      <option value="2">Model 2</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Status</label>
                    <select className="form-input" defaultValue={selectedKit.status}>
                      <option value="assigned">Assigned</option>
                      <option value="notassigned">Not Assigned</option>
                      <option value="removed">Removed</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Active</label>
                    <select className="form-input" defaultValue={selectedKit.active}>
                      <option value="assigned">Assigned</option>
                      <option value="notassigned">Not Assigned</option>
                      <option value="removed">Removed</option>
                    </select>
                  </div>
                </form>
              ) : (
                // View Details
                <>
                  <div className="detail-group">
                    <label className="detail-label">Assigned Dealer</label>
                    <div className="detail-value">{selectedKit.assignedDealer}</div>
                  </div>
                  <div className="detail-group">
                    <label className="detail-label">Zigid</label>
                    <div className="detail-value zigid-value">{selectedKit.zigid}</div>
                  </div>
                  <div className="detail-group">
                    <label className="detail-label">Model</label>
                    <div className="detail-value">v{selectedKit.model}</div>
                  </div>
                  <div className="detail-group">
                    <label className="detail-label">Status</label>
                    <div className="detail-value">
                      <span className={`status-badge ${getStatusBadgeClass(selectedKit.status)}`}>
                        {getStatusText(selectedKit.status)}
                      </span>
                    </div>
                  </div>
                  <div className="detail-group">
                    <label className="detail-label">Created Date</label>
                    <div className="detail-value">{selectedKit.createdDate}</div>
                  </div>
                  <div className="detail-group">
                    <label className="detail-label">Active</label>
                    <div className="detail-value">
                      <span className={`active-badge ${getStatusBadgeClass(selectedKit.active)}`}>
                        {getStatusText(selectedKit.active)}
                      </span>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="dialog-footer">
              <button className="dialog-btn cancel-btn" onClick={closeDialog}>
                Cancel
              </button>
              {isEditMode && (
                <button className="dialog-btn save-btn">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M2 7L5 10L12 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                  Save Changes
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalibrationKit;
